import React, { useEffect, useState } from 'react'
import request from '../../../../utils/request';
import { Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import moment from 'moment';
import AssetListItemVertical from './AssetListItemVertical';
import { Resizable } from "react-resizable";
import "react-resizable/css/styles.css"; // Import styles for resizing

import PolicyCompareQcRemarks from 'src/pages/policies/PolicyCompareQcRemarks';

function AssetListItem({ sumInsuredData, groupDetails, rfqId, type = null, policyDetail = null, qcRemarkOfEachSections = null, checkAllModuleIsVerified = null, setQcRemarkOfEachSections = null, EndorsementCompareQcRemarks = null }) {
    const QcRemarksComponent = EndorsementCompareQcRemarks || PolicyCompareQcRemarks;
    const [tableListDatas, setTableListDatas] = useState([])
    // Initialize column state with width values
    const [columns, setColumns] = useState(
        sumInsuredData?.sumInsuredHeaderSorted?.map(header => ({
            ...header,
            width: header.width ?? 150,
        })) || []
    );
    useEffect(() => {
        getAnimalListSavedDatas(rfqId);
    }, [rfqId])
    useEffect(() => {
        if (columns.length > 0)
            updateSumInsuredHeaderData();
    }, [columns])
    const getAnimalListSavedDatas = async (rfq_id, type = null) => {

        request({
            url: 'rfqOffers/getRFQassetListForOffers',
            method: 'post',
            data: {
                orderColumn: 'id',
                orderDirection: 'ASC',
                search: '',
                offset: 0,
                limit: 5000,
                status: true,
                rfqId: rfq_id,
                rfqSectionId: sumInsuredData?.id,
                groupId: parseInt(groupDetails?.id)
            }
        }).then(
            (response: any) => {

                let result = response['data'].map(
                    (sumInsuredData) => {
                        sumInsuredData.savedStatus = true;
                        return sumInsuredData;
                    }
                );

                setTableListDatas(result);

            },
            (error) => {
                console.log(error);
            }
        );
    };
    // Handle column resizing
    const handleResize = (index, event, { size }) => {
        setColumns(prevColumns => {
            const newColumns = [...prevColumns];
            newColumns[index] = { ...newColumns[index], width: size.width };
            return newColumns;
        });
    };

    const updateSumInsuredHeaderData = () => {

        request({
            url: 'rfq/updateSumInsuredSectionHeaders',
            method: 'post',
            data: {
                sumInsuredSectionid: sumInsuredData?.id,
                headerList: columns,
                "type": "UpdateStyle"
            }
        }).then(
            (response: any) => {

            },
            (error) => {
            }
        );
    }
    return (
        <>


            {sumInsuredData?.sumInsuredHeaderSorted.length <= 0 ? (
                <Alert severity="error">
                    No headings found against this section...!!
                </Alert>
            ) : (
                <div style={{
                    opacity:
                        (
                            policyDetail?.parentqcData ||
                            policyDetail?.insurancePolicy?.qcData
                        )?.sum_insured_sections?.[sumInsuredData?.id]?.status === 'approve'
                            ? 0.5
                            : 1,
                    pointerEvents:
                        (
                            policyDetail?.parentqcData ||
                            policyDetail?.insurancePolicy?.qcData
                        )?.sum_insured_sections?.[sumInsuredData?.id]?.status === 'approve'
                            ? 'none'
                            : 'auto',

                }}>
                    {groupDetails?.name && <Typography gutterBottom variant="h6" component="div" className='blockHeader' style={{ padding: '16px', color: '#fff' }}>
                        {groupDetails?.name}
                    </Typography>}
                    {sumInsuredData.isFireFloaterEnabled && <table style={{ width: '100%', borderCollapse: 'collapse', }}>
                        <tbody>
                            <tr>
                                <td style={{ padding: '2px 8px', border: '1px solid #ccc', fontWeight: 600, width: '20%' }}>
                                    Occupancy:
                                </td>
                                <td style={{ padding: '2px 8px', border: '1px solid #ccc', width: '30%' }}>
                                    {sumInsuredData?.fireFloaterOccupancy || 'N/A'}
                                </td>
                                <td style={{ padding: '2px 8px', border: '1px solid #ccc', fontWeight: 600, width: '20%' }}>
                                    Total Sum Insured:
                                </td>
                                <td style={{ padding: '2px 8px', border: '1px solid #ccc', width: '30%' }}>
                                    {new Intl.NumberFormat('en-IN', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(Number(sumInsuredData?.totalSumInsured ?? 0))}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    }
                    <div style={{ "overflowX": "auto" }}>
                        {sumInsuredData?.verticalView ? <AssetListItemVertical sumInsuredData={sumInsuredData} tableListDatas={tableListDatas} groupDetails={groupDetails} /> :
                            <TableContainer sx={{ mt: 1 }}>

                                <Table size="small" aria-label="a dense table" style={{ margin: '10px 0' }}>
                                    {/* <TableHead style={{ 'background': '#bbdcd652' }}> */}

                                        <TableRow style={{ 'background': '#bbdcd652' }}>
                                            <TableCell style={{ width: '40px', maxWidth: '40px' }}>SR No</TableCell>
                                            <>
                                                {columns.map((item, index) => (
                                                    <TableCell
                                                        key={item.title || item.sumInsuredHeader.title}
                                                        className="Pad3"
                                                        style={{ width: item.width, position: "relative" }}
                                                    >
                                                        <Resizable
                                                            width={item.width}
                                                            height={30}
                                                            onResize={(e, data) => handleResize(index, e, data)}
                                                            handle={
                                                                <span
                                                                    className="custom-resize-handle"
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: 0,
                                                                        top: 0,
                                                                        bottom: 0,
                                                                        width: "5px",
                                                                        cursor: "col-resize",
                                                                        backgroundColor: "transparent",
                                                                    }}
                                                                />
                                                            }
                                                        >
                                                            <div style={{ textAlign: "left" }}>
                                                                {item.title ? item.title : item.sumInsuredHeader.title}
                                                                {item.description && <span>*</span>}
                                                            </div>
                                                        </Resizable>
                                                    </TableCell>
                                                ))}
                                            </>





                                        </TableRow>
                                    {/* </TableHead> */}

                                    <TableBody>
                                        {tableListDatas?.map((_, index) => {
                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        '&:last-child td, &:last-child th': { border: 0 }
                                                    }}
                                                    style={{ height: '30px' }}
                                                >
                                                    <TableCell>{index + 1}</TableCell>

                                                    {sumInsuredData?.sumInsuredHeaderSorted.map((item) => {
                                                        const attr = item.sumInsuredHeader.attribute;
                                                        const value = tableListDatas[index]?.[attr];

                                                        const dateFields = [
                                                            'retroActiveDate',
                                                            'journeyStartDate',
                                                            'journeyEndDate',
                                                            'expectedDateOfCommencementOfErection',
                                                            'projectStartDateOfFirstConsignment',
                                                            'yearOfManufacture',
                                                            'dateOfCommencementOfTransit',
                                                            'invoiceNoAndDate',
                                                            'billOfLadingAndDate'
                                                        ];

                                                        const isDateField = dateFields.includes(attr);
                                                        const isFinancialField = item.isSuminsured || item.horizontalSum;

                                                        let displayValue = 'N/A';

                                                        if (Array.isArray(value)) {
                                                            displayValue = value.length
                                                                ? value.map(v => {
                                                                    if (isDateField) return moment(v).format('DD-MM-YYYY');
                                                                    if (isFinancialField) {
                                                                        return new Intl.NumberFormat('en-IN', {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 2,
                                                                        }).format(Number(v ?? 0));
                                                                    }
                                                                    return v;
                                                                }).join(', ')
                                                                : 'N/A';
                                                        } else if (value !== null && value !== undefined && value !== '') {
                                                            if (isDateField) {
                                                                displayValue = moment(value).format('DD-MM-YYYY');
                                                            } else if (isFinancialField) {
                                                                displayValue = new Intl.NumberFormat('en-IN', {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                }).format(Number(value ?? 0));
                                                            } else {
                                                                displayValue = value;
                                                            }
                                                        }

                                                        return (
                                                            <TableCell key={attr} className="Pad3">
                                                                {displayValue}
                                                            </TableCell>
                                                        );
                                                    })}

                                                </TableRow>
                                            );
                                        })}
                                        {parseFloat(groupDetails.totalSumInsured) > 0 && sumInsuredData.showTotalSumInsured ? (
                                            <TableRow>
                                                <TableCell className='Pad3'
                                                    colSpan={
                                                        sumInsuredData?.sumInsuredHeaderSorted.length
                                                    }
                                                ><Typography variant="h5" style={{ marginTop: 9, textAlign: 'right' }}>
                                                        Total
                                                    </Typography></TableCell>
                                                <TableCell className='Pad3' >
                                                    <Typography variant="h5" style={{ marginTop: 9, textAlign: 'left' }}>
                                                        : {new Intl.NumberFormat('en-IN', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2,
                                                        }).format(Number(groupDetails?.totalSumInsured ?? 0))}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : null}
                                    </TableBody>
                                </Table>

                            </TableContainer>}
                        {type == 'qc' && tableListDatas?.length > 0 && <div style={{ marginBottom: '10px' }}>
                            <QcRemarksComponent
                                modouleDetail={policyDetail}
                                qcRemarkOfEachSections={qcRemarkOfEachSections}
                                section_key={'sum_insured_sections'}
                                block_key={sumInsuredData?.id}
                                checkAllModuleIsVerified={
                                    checkAllModuleIsVerified
                                }
                                setQcRemarkOfEachSections={setQcRemarkOfEachSections}
                                sectionName={sumInsuredData?.sectionName ?? ''}
                            />
                        </div>}
                    </div>


                </div>
            )}
        </>
    )
}

export default AssetListItem